var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _g2, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpenseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6723 8.3474L17.0693 15.5194C17.0253 16.0714 16.5743 16.4854 16.0233 16.4854H16.0193H5.10828H5.10628C4.58528 16.4854 4.14028 16.0974 4.06628 15.5824L3.11628 9.0234C3.09428 8.8674 3.13328 8.7114 3.22828 8.5854C3.32228 8.4584 3.46028 8.3764 3.61628 8.3544C3.82528 8.3624 12.4983 8.3504 17.6723 8.3474V8.3474ZM16.0253 17.9854C17.3423 17.9854 18.4573 16.9574 18.5643 15.6424L19.4803 4.7484L20.9873 4.4884C21.3963 4.4164 21.6693 4.0294 21.5993 3.6204C21.5273 3.2114 21.1323 2.9454 20.7323 3.0094L18.6523 3.3694C18.3173 3.4284 18.0623 3.7064 18.0333 4.0464L17.7983 6.8474C3.52228 6.8534 3.47628 6.8604 3.40728 6.8684C2.85028 6.9494 2.36029 7.2404 2.02629 7.6884C1.69229 8.1354 1.55228 8.6864 1.63228 9.2384L2.58128 15.7964C2.76028 17.0444 3.84428 17.9854 5.10428 17.9854H5.10929H16.0173H16.0253Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.71237 12.0437H9.48438C9.89937 12.0437 10.2344 11.7077 10.2344 11.2937C10.2344 10.8797 9.89937 10.5437 9.48438 10.5437H6.71237C6.29837 10.5437 5.96238 10.8797 5.96238 11.2937C5.96238 11.7077 6.29837 12.0437 6.71237 12.0437",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4555 20.7019C16.1545 20.7019 15.9115 20.9449 15.9115 21.2459C15.9115 21.5469 16.1545 21.7909 16.4555 21.7909C16.7575 21.7909 17.0005 21.5469 17.0005 21.2459C17.0005 20.9449 16.7575 20.7019 16.4555 20.7019",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1403_8532",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 20,
    width: 3,
    height: 2
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.001 21.2455C17.001 21.5475 16.758 21.7915 16.455 21.7915V21.7915C16.154 21.7915 15.911 21.5475 15.911 21.2455V21.2455C15.911 20.9445 16.154 20.7015 16.455 20.7015V20.7015C16.758 20.7015 17.001 20.9445 17.001 21.2455V21.2455Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1403_8532)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 26.7905H10.911V15.7015H22V26.7905Z",
    fill: "black"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4565 21.0408C16.5695 21.0408 16.6615 21.1328 16.6615 21.2458C16.6615 21.4728 16.2505 21.4728 16.2505 21.2458C16.2505 21.1328 16.3435 21.0408 16.4565 21.0408M16.4565 22.5408C17.1705 22.5408 17.7505 21.9598 17.7505 21.2458C17.7505 20.5318 17.1705 19.9518 16.4565 19.9518C15.7425 19.9518 15.1615 20.5318 15.1615 21.2458C15.1615 21.9598 15.7425 22.5408 16.4565 22.5408",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.17521 20.7019C4.87421 20.7019 4.63021 20.9449 4.63021 21.2459C4.63021 21.5469 4.87421 21.7909 5.17521 21.7909C5.47721 21.7909 5.72021 21.5469 5.72021 21.2459C5.72021 20.9449 5.47721 20.7019 5.17521 20.7019",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1403_8532",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 20,
    width: 2,
    height: 2
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71997 21.2455C5.71997 21.5475 5.47697 21.7915 5.17497 21.7915V21.7915C4.87497 21.7915 4.62997 21.5475 4.62997 21.2455V21.2455C4.62997 20.9445 4.87497 20.7015 5.17497 20.7015V20.7015C5.47697 20.7015 5.71997 20.9445 5.71997 21.2455V21.2455Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1403_8532)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.72 26.7905H-0.370029V15.7015H10.72V26.7905Z",
    fill: "black"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.17621 21.0408C5.28821 21.0408 5.38021 21.1328 5.38021 21.2458C5.37921 21.4748 4.96921 21.4728 4.97021 21.2458C4.97021 21.1328 5.06321 21.0408 5.17621 21.0408M5.17621 22.5408C5.89021 22.5408 6.47021 21.9598 6.47021 21.2458C6.47021 20.5318 5.89021 19.9518 5.17621 19.9518C4.46121 19.9518 3.88021 20.5318 3.88021 21.2458C3.88021 21.9598 4.46121 22.5408 5.17621 22.5408",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenseIcon);
export default __webpack_public_path__ + "static/media/expense_icon.5fab87eefb4f13f8c4ab3dd3701a4698.svg";
export { ForwardRef as ReactComponent };